module.exports = __webpack_public_path__ + "static/theme-editor-top-banner-b7bdf4c2705d1c043c3df51193053efc.png";